import { GET_REPORT_QUERY, SMART_REPORTS_QUERY } from '../operations';

import { useQuery } from '@apollo/client';

export const useGetReports = ({
  search = '',
  order = 'desc',
  orderBy = 'createdAt',
  page = 1,
  perPage = 10,
}) => {
  const { data, loading, error } = useQuery(SMART_REPORTS_QUERY, {
    variables: {
      search,
      pagination: {
        order,
        orderBy,
        page,
        perPage,
      },
    },
  });

  return {
    reports: data?.smartReportsList?.reports || [],
    totalCount: data?.smartReportsList?.totalCount || 0,
    loading,
    error,
  };
};

export const useGetReport = (id) => {
  const { data, loading, error } = useQuery(GET_REPORT_QUERY, {
    variables: { id },
    fetchPolicy: 'network-only',
    skip: !id,
  });

  return {
    report: data?.smartReport || null,
    loading,
    error,
  };
};
